import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/scholars";

import {getNumberFormat, objectToQueryString, pushUrl} from "../../../../utils/functions"
import Dropdown from "../../../etc/dropdown";

import {SCHOLAR_ORDER_BY_OPTIONS, ORDER, BASE_PATH} from "../../../../wpconfig/index";
import * as func from "../../../../utils/functions";

class ScholarOrder extends Component {
	constructor(props) {
		super(props);
	}

	// componentDidMount() {
	// }

	handleGoto(url) {
		// window.history.pushState('', '1', 'admin.php?page=scholar&id=1');
		//
		// this.setState(() => {
		//     return {id: 1};
		// });
	}

	paramEvnet = (name, value) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[name] = value;
		if (name === 'order_by' && (value === 'title'))
			param.order = 'asc'
		else if (name === 'order_by' && (value === 'date' || value === 'count'))
			param.order = 'desc'

		dataActions.setScholars({"param": param});

		func.getData("scholars", param).then((response) => {
			dataActions.setScholars(response);
			const url = objectToQueryString(param);
			pushUrl('검색', BASE_PATH + 'scholars/?' + url, this.props.param);
			this.refs.order.reload()
		});
	}

	render() {
		return (
			<>
				<div className="d-flex align-items-center">
					<h3 className="con-title">검색결과 ({this.props.totalRecords ? getNumberFormat(this.props.totalRecords) : 0})</h3>
				</div>
				<div className="d-flex align-items-center">
					<div className="d-flex mulity-dropdown">
						<Dropdown options={SCHOLAR_ORDER_BY_OPTIONS} value={this.props.param.order_by} onChange={this.paramEvnet}
						          name="order_by"/>
						<Dropdown options={ORDER} value={this.props.param.order} onChange={this.paramEvnet}
						          name="order"
						          ref={"order"}/>
					</div>
				</div>
			</>
		)
	}
}


export default connect(
	(state) => ({
		param: state.scholars.param ? state.scholars.param : {},
		totalRecords: state.scholars.totalRecords ? state.scholars.totalRecords : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ScholarOrder)

ScholarOrder.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
